module.exports = __webpack_public_path__ + "img/购房流程.88f0f348.png";